export default function getStepRoundedServiceQuantity(quantity, service) {
  const computed = Math.ceil(quantity / service.step) * service.step;

  if (computed > service.max) {
    return computed - service.step;
  }

  return computed;
}
